/* eslint-disable import/no-dynamic-require */
import { Amplify } from 'aws-amplify';
import queryMiddleware from 'farce/queryMiddleware';
import createFarceRouter from 'found/createFarceRouter';
import createRender from 'found/createRender';
import { Resolver } from 'found-relay';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { IntlProvider } from 'react-intl';
import { Button } from 'reactstrap';

import ErrorBoundary from 'src/components/ErrorBoundary';
import HTTP404 from 'src/components/HTTP404';
import { AmplifyConfig } from 'src/config';
import routes from 'src/routes';
import environment from 'src/util/environment';
import browserProtocol from 'src/util/history';
import 'src/scss/index.scss';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import { getDefaultLocale, getLocale, i18nMessages } from 'src/util/i18n/handler';
import { intercomHandler } from 'src/util/intercom';
import logger from 'src/util/logger';

const Router = createFarceRouter({
  historyProtocol: browserProtocol,
  historyMiddlewares: [queryMiddleware],
  routeConfig: routes,

  /* eslint-disable react/prop-types */
  render: createRender({
    renderError: ({ error }) => {
      logger.log({ error });
      return error.status === 404 ? <HTTP404 /> : <div>{`Error: ${error}`}</div>;
    },
  }),
  /* eslint-enable react/prop-types */
});

Amplify.configure(AmplifyConfig());
const locale = getLocale();
const defaultLocale = getDefaultLocale(locale);
const localI18nMessages = i18nMessages();

const rootContainer = createRoot(document.getElementById('container'));
rootContainer.render(
  (
    <IntlProvider
      defaultLocale={defaultLocale}
      locale={locale}
      messages={localI18nMessages}
    >
      <HelmetProvider>
        <ErrorBoundary
          fallback={(retry) => (
            <Button onClick={retry} type="button">
              Retry
            </Button>
          )}
        >
          <Router resolver={new Resolver(environment)} />
        </ErrorBoundary>
      </HelmetProvider>
    </IntlProvider>
  ),
);
intercomHandler();
